import Interested from '../components/interestedComponent';
const NoPage = () => {
  return (
    <div className='desktop-width'>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <Interested />
    </div>
  );
};

export default NoPage;
